import { createHttpClient } from '../../../api/http';
import { serviceUrls } from '../../../config/serviceUrls';

export const platformClient = createHttpClient(serviceUrls.gateway, { timeoutMs: 30_000 });

